import { getStorage, isValidStorageKey } from '~/src/common/storage';
import { isNonEmptyString } from '~/src/common/utilities';

export function getLastTimeClosedInMs(storageKey: string): number | null {
  const storage = getStorage();

  const lastClosedInMsStorageValue = isValidStorageKey(storageKey)
    ? storage.getItem(storageKey)
    : null;

  if (!isNonEmptyString(lastClosedInMsStorageValue)) {
    return null;
  }

  const lastTimeClosedInMs = Number(lastClosedInMsStorageValue);
  if (isNaN(lastTimeClosedInMs)) {
    return null;
  }
  return lastTimeClosedInMs;
}
